import { render, staticRenderFns } from "./TokenReports.vue?vue&type=template&id=6085325b&scoped=true&"
import script from "./TokenReports.vue?vue&type=script&lang=js&"
export * from "./TokenReports.vue?vue&type=script&lang=js&"
import style0 from "./TokenReports.vue?vue&type=style&index=0&id=6085325b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085325b",
  null
  
)

export default component.exports